import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  // after every turbo load, we need to re-initialize the Zendesk script, and then hide the launcher
  // more info here on why we need to re-init: https://mentalized.net/journal/2019/04/26/zendesk-web-widget-turbolinks/
  // the suggested way to re-init is to set window.zEACLoaded = undefined; however, with this method there is no way to react
  // to the re-initialization and hide the launcher.
  // to solve this, the controller complete controls the creation and initialization of the script tag, allowing us to set an
  // onload callback and to manually remove and re-create the script on every turbo-load.
  // this delays the Time To Interact of the Zendesk launcher by a very short amount, which should not be noticable by customers.

  connect() {
    window.addEventListener('turbo:load', this.resetScript)
  }

  disconnect() {
    window.removeEventListener('turbo:load', this.resetScript)
  }

  resetScript = () => {
    if (this.scriptTag) {
      this.scriptTag.remove()
      delete this.scriptTag
    }
    window.zEACLoaded = undefined

    this.scriptTag = document.createElement('script')
    this.scriptTag.setAttribute('src', 'https://static.zdassets.com/ekr/snippet.js?key=62d8d7e9-2529-4ef6-a936-bdce96ab9aec')
    this.scriptTag.setAttribute('nonce', 'true')
    this.scriptTag.setAttribute('crossorigin', 'anonymous')
    this.scriptTag.setAttribute('id', 'ze-snippet')
    this.scriptTag.onload = () => {
      zE('webWidget', 'hide')
      zE('webWidget:on', 'close', () => {
        zE('webWidget', 'hide')
      })
    }

    document.body.appendChild(this.scriptTag)
  }
}
